export const isProduction = process.env.NODE_ENV === "production";
export const baseUrl =
  process?.env?.CANONICAL_TAG || "https://www.cobasi.com.br/";
